module.exports = __webpack_public_path__ + "img/1.b0317072.svg";